/** Spanish for one part of the app (ADR 0325); see index.ts for the house style. */
export const components: Readonly<Record<string, string>> = {
  // The list head and its date filter (DATE_FILTERS in packages/core)
  record: "registro",
  records: "registros",
  "All time": "Todo el tiempo",
  Today: "Hoy",
  "This week": "Esta semana",
  "This month": "Este mes",
  "This quarter": "Este trimestre",
  "This year": "Este año",

  // The job table
  Customer: "Cliente",
  Address: "Dirección",
  Bid: "Oferta",
  Status: "Estado",
  Rep: "Vendedor",
  Value: "Valor",
  "Nothing here": "Nada por aquí",
  "No records match the current filters.":
    "Ningún registro coincide con los filtros actuales.",
  Test: "Prueba",
  Repair: "Reparación",
  Retail: "Particular",
  Insurance: "Seguro",
  "New Lead": "Nuevo prospecto",
  Contacted: "Contactado",
  "Inspection Scheduled": "Inspección programada",
  Inspected: "Inspeccionado",
  "Proposal Sent": "Propuesta enviada",
  Signed: "Firmado",
  "In Production": "En producción",
  Complete: "Completado",
  Closed: "Cerrado",
  Lost: "Perdido",
  "No price yet": "Sin precio aún",

  // The figures over a list
  "On this list": "En esta lista",
  "In the pipeline": "En el embudo",
  "1 job not sold yet": "1 trabajo sin vender",
  "{n} jobs not sold yet": "{n} trabajos sin vender",
  "Signed this month": "Firmados este mes",
  "Need a call": "Necesitan llamada",
  "Over 48 hours": "Más de 48 horas",
  "Nobody is waiting": "Nadie está esperando",

  // A modal
  Close: "Cerrar",

  // The balance card
  Balance: "Saldo",
  "{amount} left": "Faltan {amount}",
  "Paid up": "Pagado por completo",
  "{way} on its way — paid, not yet in the bank. The whole balance is {all} until it lands.":
    "{way} en camino — pagado, aún no en el banco. El saldo completo es {all} hasta que llegue.",
  "{slot} link for {amount}, invoice {invoice}.":
    "Enlace de {slot} por {amount}, factura {invoice}.",
  "{slot} link, invoice {invoice}.": "Enlace de {slot}, factura {invoice}.",
  "Earlier payment": "Pago anterior",
  "First Payment": "Primer pago",
  "Second Payment": "Segundo pago",
  "Third Payment": "Tercer pago",
  "Final Payment": "Pago final",
  unknown: "desconocida",
  "Still live at Mercury, and the final payment request bills it again. The customer could pay it twice. It has not been cancelled yet; void it in Mercury by hand.":
    "Sigue activo en Mercury y la solicitud del pago final lo vuelve a cobrar. El cliente podría pagarlo dos veces. Aún no se ha cancelado; anularlo en Mercury a mano.",
  "Payment plan": "Plan de pagos",
  "In the bank": "En el banco",
  "Check clearing": "Cheque en proceso",
  "Not yet": "Todavía no",
  Contract: "Contrato",
  "{amount} received": "{amount} recibidos",
  "Nothing received": "Nada recibido",
  Cash: "Efectivo",
  Check: "Cheque",
  Card: "Tarjeta",
  "Bank transfer": "Transferencia bancaria",
  Financing: "Financiamiento",
  ", payment plan": ", plan de pagos",
  "Receipted by Mercury": "Recibo emitido por Mercury",
  "Receipt {n} emailed": "Recibo {n} enviado por email",
  "Receipt not emailed: {error}": "Recibo no enviado: {error}",
  "Sending receipt…": "Enviando recibo…",
  "No receipt yet": "Sin recibo aún",
  "Send receipt": "Enviar recibo",
  "Mark in the bank": "Marcar en el banco",
  "Record check or cash": "Registrar cheque o efectivo",
  "Payment link for another amount": "Enlace de pago por otro monto",
  "Received means the money is in the bank: through Mercury, as cash recorded here, or as a check once Mercury shows it deposited.":
    "Recibido significa que el dinero está en el banco: por Mercury, como efectivo registrado aquí, o como cheque cuando Mercury lo muestre depositado.",
  "Customer is paying by check": "El cliente paga con cheque",
  "Paying by check. Payment reminders are paused until {date}; recording the check ends the wait, and if nothing has arrived by then they start again.":
    "Pago con cheque. Los recordatorios de pago están en pausa hasta el {date}; registrar el cheque termina la espera, y si nada ha llegado para entonces, vuelven a empezar.",
  "A check was expected by {date} and none has been recorded, so the payment reminders are going again.":
    "Se esperaba un cheque para el {date} y no se ha registrado ninguno, así que los recordatorios de pago están activos de nuevo.",
  "Still coming — wait another {n} days":
    "Sigue en camino — esperar otros {n} días",
  "Not paying by check": "No paga con cheque",
  "Turn off payment reminders": "Desactivar recordatorios de pago",
  "Payment reminders are off for this job since {date}. The customer is not emailed about a payment until they are turned back on.":
    "Los recordatorios de pago están desactivados en este trabajo desde el {date}. No se le envía email al cliente sobre ningún pago hasta que se vuelvan a activar.",
  "Turn payment reminders back on": "Volver a activar recordatorios de pago",
  "Payment plan: {monthly} a month. {made} of {total} payments made, {left} left on the plan.":
    "Plan de pagos: {monthly} al mes. {made} de {total} pagos hechos, faltan {left} del plan.",
  "The plan is paid off.": "El plan está liquidado.",
  "Late: {amount} was due {date}, {days} days ago. Call the customer.":
    "Atrasado: {amount} vencía el {date}, hace {days} días. Llamar al cliente.",
  "Next: {amount} due {date}.": "Siguiente: {amount} vence el {date}.",

  // The address box
  "(approx. — street match)": "(aprox. — coincide la calle)",
  "No match on the map": "Sin coincidencia en el mapa",
  "Check the street spelling, or just type the address and fill in the city, state and zip yourself.":
    "Revisar la ortografía de la calle, o simplemente escribir la dirección y llenar ciudad, estado y código postal a mano.",

  // The inspection form
  Date: "Fecha",
  Time: "Hora",
  "Inspection date": "Fecha de inspección",
  "Inspection time": "Hora de inspección",
  "How long": "Duración",
  "{n} min": "{n} min",
  "No email address for {names}, so they will not get the invitation — ring them, or add an address under Tools.":
    "No hay email para {names}, así que no recibirán la invitación — llamarles, o agregar un email en Herramientas.",
  or: "o",
  "Who is going": "Quién va",
  "Pick an inspector or crew…": "Elegir un inspector o cuadrilla…",
  "Second person or crew (optional)": "Segunda persona o cuadrilla (opcional)",
  "Anyone else going…": "Alguien más que vaya…",
  "Notes (paste anything the inspector should see)":
    "Notas (pegar lo que el inspector deba ver)",
  Inspection: "Inspección",
  Remove: "Quitar",
  "+ Schedule inspection": "+ Programar inspección",

  // Picking a person or a crew
  "Search staff and crews by name…": "Buscar personal y cuadrillas por nombre…",
  Crew: "Cuadrilla",

  // A colleague on the same customer
  and: "y",
  "has job #{n} open since {time}":
    "tiene abierto el trabajo #{n} desde las {time}",
  "has job #{n} open": "tiene abierto el trabajo #{n}",
  "has the customer file open since {time}":
    "tiene abierta la ficha del cliente desde las {time}",
  "has the customer file open": "tiene abierta la ficha del cliente",
  "{names} is on this customer": "{names} está con este cliente",
  "{names} are on this customer": "{names} están con este cliente",
  "{names} is working on this customer":
    "{names} está trabajando con este cliente",
  "{names} are working on this customer":
    "{names} están trabajando con este cliente",
  "Got it": "Entendido",
  "Check with {names} before you call, text or change anything for {customer}, so you don't step on each other.":
    "Consultar con {names} antes de llamar, escribir o cambiar algo de {customer}, para no pisarse entre sí.",

  // Undo and redo
  "Undid: {label}": "Deshecho: {label}",
  Dismiss: "Descartar",
  Undo: "Deshacer",
  "Removed {what}": "Se quitó {what}",
  "Added a line": "Línea agregada",
  "Remove this line": "Quitar esta línea",
  "Undo: {label}": "Deshacer: {label}",
  "Nothing to undo": "Nada que deshacer",
  "Redo: {label}": "Rehacer: {label}",
  "Nothing to redo": "Nada que rehacer",
  "↶ Undo": "↶ Deshacer",
  "↷ Redo": "↷ Rehacer",
};
